import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import SelectingSwitcherSwitches from './SelectingFiltersSwitches'
import FilterInputsContact from './Contact/FilterInputsContact'
import FilterInputsMerchant from './Merchant/FilterInputsMerchant'
import FilterInputsCustomerLogistics from './CustomerLogistics/FilterInputsCustomerLogistics'
import FilterInputsTSDealers from './TSDealers/FilterInputsTSDealers'
import FilterInputsFinanceDealers from './FinanceDealers/FilterInputsFinanceDealers'
import FilterInputsEmailTemplate from './EmailTemplate/FilterInputsEmailTemplate'
import { withRouter } from 'react-router-dom'
import {
  getContactFilterTypes,
  loadContactFilters,
  createContactFilterType,
  switchChanges,
  addContactFilters,
  setFiltersValue,
  getOptions,
  getUsersForDivision,
  deleteFilterType,
  removeFilter,
  clearFilters,
} from './redux/ContactFiltersActions'
import {
  MERCHANT_FILTERS,
  CONTACT_FILTERS,
  TRUCK_SALES_DEALER_FILTERS,
  FINANCE_DEALER_FILTERS,
  SHIPPERS_FILTERS,
  EMAIL_TEMPLATE_FILTERS,
} from '../../../constants/contactFilterCategory'
import { validateContactFilters } from '../../../utils/validateContactFilters'

class selectingFilters extends React.Component {
  state = {
    selectedFilters: {},
    contactFilterTypes: [],
    selectedType: null,
    selectedFiltersValues: {},
    options: [],
    isAddingNew: false,
    newPresetName: '',
    allContactsOnly: false,
  }

  async componentDidMount() {
    const { getContactFilterTypes, userId, selectedFiltersValues, filterCategory } = this.props
    if (userId) {
      await getContactFilterTypes(userId, filterCategory)
    }
    this.setState({ selectedFiltersValues })

    const { location } = this.props
    const allContactsOnly = !!(
      location?.pathname.includes('/all-customers') || location?.pathname.includes('/contacts')
    )

    if (allContactsOnly) {
      this.setState((prev) => ({
        ...prev,
        allContactsOnly,
      }))
    }
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.selectedFiltersValues?.contact_division_id != this.state.selectedFiltersValues?.contact_division_id &&
      this.state.selectedFiltersValues?.contact_division_id
    ) {
      this.props.getUsersForDivision(this.state.selectedFiltersValues.contact_division_id).then(() => {
        this.setState((prev) => ({
          ...prev,
          options: this.props.nationalities,
        }))
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedFilters && props.selectedFilters !== state.selectedFilters) {
      return {
        selectedFilters: props.selectedFilters,
        selectedType: props.typeId,
        options: props.nationalities,
      }
    }
    if (props.selectedFilters && props.selectedFiltersValues !== state.selectedFiltersValues) {
      return {
        selectedFiltersValues: props.selectedFiltersValues,
      }
    }
    if (props.contactFilterTypes && props.contactFilterTypes !== state.contactFilterTypes) {
      return {
        contactFilterTypes: props.contactFilterTypes,
        userId: props.userId,
      }
    }
    return null
  }

  handleSwitchChange = (event, isExtension) => {
    const { name, value, id } = event.target
    this.props.switchChanges(name, value, id, 'contact', isExtension)
  }

  handleFiltersChanges = (event, type, field, nthValue) => {
    const { selectedFiltersValues } = this.props
    if (type === 'zip') {
      const { name, value } = event.target
      this.props.setFiltersValue(name, { ...selectedFiltersValues[name], [field]: value })
      return
    }

    if (type === 'select') {
      const { id: value } = event
      if (nthValue) {
        this.props.setFiltersValue(field, {
          ...selectedFiltersValues[field],
          [nthValue]: value,
        })
        return
      } else {
        this.props.setFiltersValue(field, value)
        return
      }
    }
    if (type === 'from') {
      this.props.setFiltersValue(event.target.name, {
        ...selectedFiltersValues[event.target.name],
        from: event.target.value,
      })
      return
    }
    if (type === 'to') {
      this.props.setFiltersValue(event.target.name, {
        ...selectedFiltersValues[event.target.name],
        to: event.target.value,
      })
      return
    }
    const { name, value } = event.target
    this.props.setFiltersValue(name, value)
  }

  saveNewPreset = async () => {
    const { userId, newPresetName } = this.state

    const response = await this.props.createContactFilterType({
      userId,
      name: newPresetName,
      createdBy: 1,
      lastUpdatedBy: 1,
      category_id: this.props.filterCategory,
    })
    this.setState((state) => {
      return {
        ...state,
        isAddingNew: false,
        selectedType: response.id,
      }
    })
  }

  handlePresetChange = (value) => {
    this.props.loadContactFilters(value ? value.id : null)
  }

  deletePreset = async () => {
    await this.props.deleteFilterType(this.state.selectedType)
    await this.props.getContactFilterTypes(this.props.userId, this.props.filterCategory)
  }

  handleChange = (event) => {
    const { name, value } = event.target
    this.setState((state) => {
      return {
        ...state,
        [name]: value,
      }
    })
  }

  sendFilters = async () => {
    const { selectedType, selectedFilters } = this.state
    let key
    let newFilters = {}
    for (key in selectedFilters) {
      if (selectedFilters[key]) {
        newFilters = {
          ...newFilters,
          [key]: !!selectedFilters[key],
        }
      }
    }
    this.props.addContactFilters({ filters: newFilters, typeId: selectedType })
  }

  toggleAddNewPreset = () => {
    this.setState((state) => {
      return {
        ...state,
        isAddingNew: true,
      }
    })
  }

  setValuesFilter = () => {
    let returnedValues = {}
    const { selectedFiltersDB, selectedFiltersValues, extension } = this.props
    selectedFiltersDB.forEach((item) => {
      if (item.extension) {
        returnedValues = { ...returnedValues, [extension + item.name]: selectedFiltersValues[item.name] }
      } else {
        returnedValues = { ...returnedValues, [item.name]: selectedFiltersValues[item.name] }
      }
    })
    return returnedValues
  }

  setFiltersInUrl = (customFilter) => {
    const { loadData, match, query, previousTableFilters, clearFilters } = this.props
    const { path } = match
    const validateFilters = validateContactFilters(
      this.props.selectedFilters,
      this.props.selectedFiltersValues,
      this.props.filterCategory
    )
    if (validateFilters) {
      let valuesFilter = {}
      if (this.props.extension) {
        valuesFilter = this.setValuesFilter()
      } else {
        if (customFilter) {
          valuesFilter = { ...this.props.selectedFiltersValues, ...customFilter }
        } else {
          valuesFilter = { ...this.props.selectedFiltersValues }
        }
      }
      const stringifyFilters = JSON.stringify(valuesFilter)

      if (query) {
        let stringifyQuery = {}
        if (previousTableFilters) {
          stringifyQuery = JSON.stringify({
            query: query,
            ...valuesFilter,
            ...previousTableFilters,
          })
        } else {
          stringifyQuery = JSON.stringify({
            query: query,
            ...valuesFilter,
          })
        }
        window.open(`/master-data-table/?${stringifyQuery}`, '_blank')
      } else {
        window.open(`${path === '/' ? '/master-data-table' : path}?${encodeURIComponent(stringifyFilters)}`, '_blank')
      }
      clearFilters()
      loadData()
    }
  }

  render() {
    const {
      contactFilterTypes,
      selectedFilters,
      selectedType,
      isAddingNew,
      newPresetName,
      selectedFiltersValues,
      options,
      allContactsOnly,
    } = this.state
    return (
      <>
        <SelectingSwitcherSwitches
          contactFilterTypes={contactFilterTypes}
          selectedFilters={selectedFilters}
          selectedType={selectedType}
          isAddingNew={isAddingNew}
          newPresetName={newPresetName}
          handlePresetChange={this.handlePresetChange}
          handleChange={this.handleChange}
          saveNewPreset={this.saveNewPreset}
          handleSwitchChange={this.handleSwitchChange}
          toggleAddNewPreset={this.toggleAddNewPreset}
          sendFilters={this.sendFilters}
          filterCategory={this.props.filterCategory}
          extension={this.props.extension}
          deletePreset={this.deletePreset}
        />
        <hr />
        {this.props.filterCategory === CONTACT_FILTERS && (
          <FilterInputsContact
            allContactsOnly={allContactsOnly}
            setFiltersValue={setFiltersValue}
            selectedFilters={selectedFilters}
            handleFiltersChanges={this.handleFiltersChanges}
            loadData={this.setFiltersInUrl}
            selectedFiltersValues={selectedFiltersValues}
            getOptions={this.props.getOptions}
            options={options}
            removeFilter={removeFilter}
          />
        )}
        {this.props.filterCategory === MERCHANT_FILTERS && (
          <FilterInputsMerchant
            selectedFilters={selectedFilters}
            handleFiltersChanges={this.handleFiltersChanges}
            loadData={this.setFiltersInUrl}
            selectedFiltersValues={selectedFiltersValues}
            getOptions={this.props.getOptions}
            options={options}
          />
        )}
        {this.props.filterCategory === SHIPPERS_FILTERS && (
          <FilterInputsCustomerLogistics
            allContactsOnly={allContactsOnly}
            setFiltersValue={setFiltersValue}
            selectedFilters={selectedFilters}
            handleFiltersChanges={this.handleFiltersChanges}
            loadData={this.setFiltersInUrl}
            selectedFiltersValues={selectedFiltersValues}
            getOptions={this.props.getOptions}
            options={options}
            removeFilter={removeFilter}
          />
        )}
        {this.props.filterCategory === TRUCK_SALES_DEALER_FILTERS && (
          <FilterInputsTSDealers
            selectedFilters={selectedFilters}
            handleFiltersChanges={this.handleFiltersChanges}
            loadData={this.setFiltersInUrl}
            selectedFiltersValues={selectedFiltersValues}
            getOptions={this.props.getOptions}
            options={options}
          />
        )}
        {this.props.filterCategory === FINANCE_DEALER_FILTERS && (
          <FilterInputsFinanceDealers
            setFiltersValue={setFiltersValue}
            removeFilter={removeFilter}
            selectedFilters={selectedFilters}
            handleFiltersChanges={this.handleFiltersChanges}
            loadData={this.setFiltersInUrl}
            selectedFiltersValues={selectedFiltersValues}
            getOptions={this.props.getOptions}
            options={options}
          />
        )}
        {this.props.filterCategory === EMAIL_TEMPLATE_FILTERS && (
          <FilterInputsEmailTemplate
            selectedFilters={selectedFilters}
            setFiltersValue={setFiltersValue}
            handleFiltersChanges={this.handleFiltersChanges}
            loadData={this.setFiltersInUrl}
            selectedFiltersValues={selectedFiltersValues}
            getOptions={this.props.getOptions}
            options={options}
          />
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  contactFilterTypes: state.contactFilters.types,
  selectedFilters: state.contactFilters.filters,
  selectedFiltersDB: state.contactFilters.filtersDB,
  selectedFiltersValues: state.contactFilters.filtersValues,
  nationalities: state.contactFilters.nationalities,
  typeId: state.contactFilters.typeId,
  userId: state.auth.user.userId,
  errors: state.errors,
})

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getContactFilterTypes,
    loadContactFilters,
    createContactFilterType,
    switchChanges,
    addContactFilters,
    setFiltersValue,
    getOptions,
    getUsersForDivision,
    deleteFilterType,
    clearFilters,
  })
)(selectingFilters)
